$(function () {

    var userAgent = window.navigator.userAgent.toLowerCase();
    var msg_flg = false;

    if(userAgent.indexOf('msie') != -1 ||
        userAgent.indexOf('trident') != -1) {
        msg_flg = true;
    } else if(userAgent.indexOf('edge') != -1) {

    } else if(userAgent.indexOf('chrome') != -1) {

    } else if(userAgent.indexOf('safari') != -1) {

    } else if(userAgent.indexOf('firefox') != -1) {
        msg_flg = true;
    } else if(userAgent.indexOf('opera') != -1) {
        msg_flg = true;
    } else {
        msg_flg = true;
    }

    if(msg_flg){
        document.getElementById("err_browser").innerHTML = 'お使いのブラウザは正常に動作しない場合がございます。<br>お手数ですが、Google Chromeをご利用ください。';
        document.getElementById("err_browser_area").style.display ="block";
    }

});
